import actions from './actions';
import { RequestService as req } from "../../services/requestService";
import { Constants } from "../../config/constants";
import {
    fetchStudentUnseenEmails,
    fetchTeacherUnseenEmails,
    fetchUnseenOfficialEmails
} from "../notifications/actionCreator";

const {
    fetchAllStudentEmailsAction,
    fetchAllStudentInfoAction,
    fetchAllTeacherInfoAction,
    fetchAllTeacherEmailsAction,
    fetchTeacherEmailsAction,
    fetchTeacherUnifiedEmailsAction,
    fetchTeacherSentEmailsAction,
    fetchStudentEmailsAction,
    fetchAllOfficialEmailsAction,
    fetchClassTeacherZoomEmailsAction
} = actions;


export const fetchAllStudentEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-student-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllStudentEmailsAction(cb)));
    };
};

export const fetchAllStudentInfo = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-student-info`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllStudentInfoAction(cb)));
    };
};

export const updateZoomPhotoStatus = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}students/zoom/photo/status`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchAllStudentInfo(data.filters))
            if (action) await action();
        })
    };
};


// ============================
// 🔹 Teacher Emails
// ============================

// Fetch Teacher Emails (list)
export const fetchAllTeacherEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-teacher-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllTeacherEmailsAction(cb)));
    };
};

export const fetchAllTeacherInfo = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-teacher-info`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllTeacherInfoAction(cb)));
    };
};

export const fetchTeacherEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTeacherEmailsAction(cb)));
    };
};

export const fetchTeacherSentEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-sent-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTeacherSentEmailsAction(cb)));
    };
};

export const fetchTeacherUnifiedEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-unified-emails`,
            queries,
            auth: 'bearer'
        }, async (cb) => {

            await dispatch(fetchTeacherUnseenEmails());
            await dispatch(fetchTeacherUnifiedEmailsAction(cb))
        });
    };
};

export const archiveTeacherEmailThread = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-unified-emails/archive/${data?.threadId}`,
            auth: 'bearer',
            body: { archive: data?.archive ?? true }
        }, async (cb) => {
            if (data?.queries) {
                await dispatch(fetchTeacherUnifiedEmails(data.queries));
            }
            if (action) await action(cb);
        });
    };
};

// Update Teacher Email Seen Status
export const updateTeacherEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            console.log("let it be", cb)
            await dispatch(fetchTeacherUnseenEmails());
            await dispatch(fetchTeacherUnifiedEmails({ page: data?.page, perPage: data?.perPage }));
            if (action) await action(); // Optional callback
        });
    };
};

export const updateAllTeacherEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}teacher-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch(fetchAllTeacherEmails({ page: data.page, perPage: data.perPage }));
            if (action) await action(); // Optional callback
        });
    };
};

// ============================
// 🔹 Student Emails
// ============================

// Fetch My Students Emails
export const fetchStudentEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}my-students-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchStudentEmailsAction(cb)));
    };
};

export const fetchClassTeacherZoomEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}class-teacher-zoom-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchClassTeacherZoomEmailsAction(cb)));
    };
};

export const fetchAllClassTeacherZoomEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-class-teacher-zoom-emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchClassTeacherZoomEmailsAction(cb)));
    };
};

// Update My Student Email Seen Status
export const updateStudentEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}my-students-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the student list after update
            await dispatch(fetchStudentUnseenEmails());
            await dispatch(fetchStudentEmails({ page: data.page, perPage: data.perPage }));
            if (action) await action(); // Optional callback
        });
    };
};

export const updateClassTeacherZoomEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}class-teacher-zoom-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the student list after update
            await dispatch(fetchStudentUnseenEmails());
            await dispatch(fetchClassTeacherZoomEmails({ page: data.page, perPage: data.perPage }));
            if (action) await action(); // Optional callback
        });
    };
};

export const updateAllClassTeacherZoomEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}class-teacher-zoom-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the student list after update
            // await dispatch(fetchStudentUnseenEmails());
            await dispatch(fetchAllClassTeacherZoomEmails({ page: data.page, perPage: data.perPage }));
            if (action) await action(); // Optional callback
        });
    };
};

export const updateAllStudentEmailSeenStatus = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}my-all-students-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the student list after update
            await dispatch(fetchAllStudentEmails(data?.filters));
            if (action) await action(); // Optional callback
        });
    };
};

// ============================
// 🔹 Student Emails
// ============================

export const fetchOfficialTeacherEmails = (queries) => {

    return async dispatch => {
        await req.getRequest({
            url: `${Constants.DOMAIN_EMAILS}all-official-emails`,
            queries,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch (fetchUnseenOfficialEmails())
            await dispatch(fetchAllOfficialEmailsAction(cb))
        } );
    };
};

export const updateAllOfficialEmailSeenStatus = (data, action = null) => {

    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}official-emails/${data?._id}`,
            auth: 'bearer',
            body: {} // No body needed for mark-seen
        }, async (cb) => {
            // Refresh the teacher list after update
            await dispatch (fetchUnseenOfficialEmails())
            await dispatch(fetchOfficialTeacherEmails(data?.filters));
            if (action) await action(); // Optional callback
        });
    };
};

export const updateOfficialEmailRating = (data, action = null) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.DOMAIN_EMAILS}official-emails-rating/${data?._id}`,
            auth: 'bearer',
            // Wrap it in an object so the backend receives req.body.rating
            body: { rating: data?.rating }
        }, async (cb) => {
            // Refresh the email list after update
            await dispatch(fetchOfficialTeacherEmails(data?.filters));
            if (action) await action(); // Optional callback
        });
    };
};

// Add to your action creators list:
export const fetchTeacherEmailThreadDetails = (threadId) => {
    return async () => {
        return new Promise((resolve, reject) => {
            req.getRequest({
                url: `${Constants.DOMAIN_EMAILS}teacher-unified-emails/thread/${threadId}`,
                auth: 'bearer'
            }, (cb) => {
                if (cb) {
                    // Otherwise, if 'cb' itself is directly the array, fall back to 'cb'.
                    const payloadData = cb.data !== undefined ? cb.data : cb;
                    resolve(payloadData);
                } else {
                    reject("Failed to load thread details from server.");
                }
            });
        });
    };
};

export const fetchOfficialEmailThreadDetails = (threadId) => {
    return async () => {
        return new Promise((resolve, reject) => {
            req.getRequest({
                url: `${Constants.DOMAIN_EMAILS}official-emails/thread/${threadId}`,
                auth: 'bearer'
            }, (cb) => {
                if (cb) {
                    const payload = cb.data !== undefined ? cb.data : cb;
                    resolve(payload);
                } else {
                    reject("Failed to retrieve official thread details.");
                }
            });
        });
    };
};